export default "__VITE_ASSET__DgNushl5__"